<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
          <el-row>
            <el-col :span="2" :lg="2">
              <el-select v-model="status" placeholder="状态" clearable size="medium" style="width: 90%;">
                <el-option label="全部状态" value="3" key="3"></el-option>
                <el-option label="禁用" value="0" key="0"></el-option>
                <el-option label="正常" value="1" key="1"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2" :lg="2">
              <el-select placeholder="渠道" clearable size="medium" v-model="searchChannelSelect"
                @change="searchChannelSelectChange" @focus="searchGetChannel" style="width: 90%;">
                <el-option value="-1" key="-1" label="全部"></el-option>
                <el-option v-for="channel in searchChannels" :value="channel.channelId" :key="channel.channelId"
                  :label="channel.channelName" />
              </el-select>
            </el-col>
            <el-col :span="3" :lg="3">
              <el-select placeholder="会员类型" clearable size="medium" v-model="searchUserCategorySelect"
                @change="searchUserCategorySelectChange" style="width: 90%">
                <el-option value="-1" key="-1" label="全部"></el-option>
                <el-option v-for="option in searchUserCategoryOptions" :value="option.value" :key="option.value"
                  :label="option.label" />
              </el-select>
            </el-col>
            <el-col :span="2" :lg="2">
              <el-select placeholder="区域" clearable size="medium" v-model="searchRegionalSubBranchSelect"
                @change="searchRegionalSubBranchChange" @focus="searchGetRegionalSubBranch" style="width: 90%;">
                <el-option value="-1" key="-1" label="全部"></el-option>
                <el-option v-for="regionalSubBranch in searchRegionalSubBranchs" :value="regionalSubBranch"
                  :key="regionalSubBranch" :label="regionalSubBranch" />
              </el-select>
            </el-col>
            <el-col :span="3" :lg="3">
              <el-select placeholder="网点" clearable size="medium" v-model="searchUnitOutletSelect"
                @change="searchUnitOutletChange" style="width: 90%;">
                <el-option value="-1" key="-1" label="全部"></el-option>
                <el-option v-for="unitOutlet in searchUnitOutlets" :value="unitOutlet" :key="unitOutlet"
                  :label="unitOutlet" />
              </el-select>
            </el-col>
            <el-col :span="5" :lg="5">
              <el-date-picker v-model="registerTime" style="width: 90%;" align="center" type="daterange" size="medium"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-col>
            <el-col :span="5" :lg="5">
              <el-input size="medium" clearable style="width: 90%;" placeholder="姓名、电话、渠道、微信昵称"
                v-model="key"></el-input>
            </el-col>
            <el-col :span="2" :lg="2">
              <el-button size="medium" style="width: 90%;" type="primary" @click="searchUser"
                icon="el-icon-search">搜索</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" :lg="2" :offset="20">
              <el-button style="width: 90%;" @click="exportUser" type="success" size="medium"
                v-if="checkButtonPermission('user:manage:list:export')">导出</el-button>
            </el-col>
            <el-col :span="2" :lg="2">
              <el-button size="medium" type="success" @click="openDialog('add', null)"
                v-if="checkButtonPermission('user:manage:list:add')">新增会员</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <div>
        <el-table :data="tableData" border fixed min-height="400" style="width: 100%">
          <el-table-column prop="userName" label="用户名" min-width="70"></el-table-column>
          <el-table-column prop="realName" label="真实姓名" min-width="70"></el-table-column>
          <el-table-column prop="wechatNickName" label="微信昵称" min-width="70"></el-table-column>
          <!--<el-table-column prop="wechatNumber" label="微信号"></el-table-column>-->
          <el-table-column prop="telephone" label="电话" min-width="100"></el-table-column>
          <el-table-column prop label="渠道" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.channel != null" v-html="scope.row.channel.channelName"></span>
            </template>
          </el-table-column>
          <el-table-column prop label="区域" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.regionalSubBranch != null" v-html="scope.row.regionalSubBranch"></span>
            </template>
          </el-table-column>
          <el-table-column prop label="网点" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.companyName != null" v-html="scope.row.companyName"></span>
            </template>
          </el-table-column>
          <el-table-column prop label="网点编号" min-width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.branchNo != null" v-html="scope.row.branchNo"></span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="integral" label="积分" min-width="60"></el-table-column> -->
          <el-table-column prop="userCategory" label="会员类型" min-width="70">
            <template slot-scope="scope">{{ scope.row.userCategory === 1 ? '推手' : '普通用户' }}</template>
          </el-table-column>
          <!-- <el-table-column prop="qrCode" label="二维码">
            <template slot-scope="scope">
              <img :src="scope.row.qrCode" min-width="32" height="32" />
            </template>
          </el-table-column> -->
          <el-table-column prop="countcustom" label="客户数量" min-width="70"></el-table-column>
          <el-table-column prop="registerTime" label="注册时间" min-width="130"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">正常</span>
              <span v-else-if="scope.row.status === 0">禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="320" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openDialog('edit', scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('user:manage:list:edit')">编辑</el-button>
              <el-button @click="openDialog('info', scope.row)" type="info"
                style="background-color: #7266ba; border-color: #7266ba;" size="mini"
                v-if="checkButtonPermission('user:manage:list:detail')">详情</el-button>
              <el-button v-if="scope.row.status == 1 && checkButtonPermission('user:manage:list:enable')"
                @click="updateUserStatus(scope.row.userId, 0)" type="danger" size="mini">禁用</el-button>
              <el-button v-if="scope.row.status == 0 && checkButtonPermission('user:manage:list:enable')"
                @click="updateUserStatus(scope.row.userId, 1)" type="success" size="mini">启用</el-button>

              <el-button @click="deleteUser(scope.row.userId)" type="danger" size="mini"
                v-if="checkButtonPermission('user:manage:list:delete')">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="addUserDialogTitle + '会员'" :visible.sync="addUserDialogVisible" :modal="false"
      :close-on-click-modal="false" @closed="resetForm('userForm')" @open="openDialogEvent(addFlag)">
      <el-form :model="userForm" ref="userForm" :rules="userRules" label-width="120px" size="medium"
        style="padding: 0 10%;">
        <el-form-item label="用户名" prop="userName">
          <span v-if="'info' == addFlag" v-html="userForm.userName"></span>
          <el-input v-else v-model="userForm.userName" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="telephone">
          <span v-if="'info' == addFlag" v-html="userForm.telephone"></span>
          <el-input v-else v-model="userForm.telephone" clearable></el-input>
        </el-form-item>
        <el-form-item label="会员类型" prop="userCategory">
          <span v-if="'info' == addFlag" v-html="userForm.userCategory == 0 ? '普通用户' : '推手'"></span>
          <el-select v-else @change="userCategoryChange" v-model="userCategorySelect">
            <el-option label="普通用户" value="0" key="0"></el-option>
            <el-option label="推手" value="1" key="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName">
          <span v-if="userForm.userCategory != 1 || 'info' == addFlag" v-html="userForm.realName"></span>
          <el-input v-else v-model="userForm.realName" clearable></el-input>
        </el-form-item>
        <el-form-item label="渠道" prop="channelId">
          <span v-if="'info' == addFlag" v-html="userForm.channel.channelName"></span>
          <el-select v-else @change="channelChangeEvent" v-model="userChannelSelect">
            <el-option v-for="channel in channels" :label="channel.channelName" :value="channel.channelId"
              :key="channel.channelId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域" prop="regionalSubBranch">
          <span v-if="userForm.userCategory != 1 || 'info' == addFlag" v-html="userForm.regionalSubBranch"></span>
          <el-input v-else v-model="userForm.regionalSubBranch" clearable></el-input>
        </el-form-item>
        <el-form-item label="网点" prop="companyName">
          <span v-if="userForm.userCategory != 1 || 'info' == addFlag" v-html="userForm.companyName"></span>
          <el-input v-else v-model="userForm.companyName" clearable></el-input>
        </el-form-item>
        <el-form-item label="网点编号" prop="branchNo">
          <span v-if="userForm.userCategory != 1 || 'info' == addFlag" v-html="userForm.branchNo"></span>
          <el-input v-else v-model="userForm.branchNo" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="'add' != addFlag" label="积分" prop="telephone">
          <span>{{ userForm.integral }}</span>
        </el-form-item>
        <el-form-item v-if="'add' != addFlag" label="客户数量" prop="userCount">
          <span>{{ userForm.userCount }}</span>
        </el-form-item>
        <el-form-item v-if="'add' != addFlag" label="注册时间" prop="registerTime">
          <span>{{ userForm.registerTime }}</span>
        </el-form-item>
        <el-form-item size="large">
          <el-button
            @click="addUserDialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitUserForm('userForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--<el-dialog :visible.sync="uploadDialogVisible">
      <img width="100%" :src="userForm.carCategoryImage" alt="">
    </el-dialog>-->
  </div>
</template>

<script>
import { reqCode, dialogAction } from "@/common/const";
export default {
  name: "userList",
  data() {
    return {
      key: "",
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      totalPage: 100,
      total: 100000,
      addUserDialogTitle: "新增",
      addUserDialogVisible: false,
      addFlag: "add",
      userForm: {},
      userRules: {},
      userId: "",
      userCategorySelect: "0",
      userChannelSelect: "",
      channels: [],
      status: "",
      registerTime: [],
      searchChannels: [],
      searchStatusSelect: "",
      searchChannelSelect: "",
      searchChannelSelectVal: "",
      searchUserCategoryOptions: [
        {
          value: 1,
          label: "推手"
        },
        {
          value: 0,
          label: "普通会员"
        }
      ],
      searchUserCategorySelect: "",
      searchUserCategorySelectVal: "",
      searchRegionalSubBranchs: [],
      searchRegionalSubBranchSelect: "",
      searchRegionalSubBranchVal: "",
      searchUnitOutlets: [],
      searchUnitOutletSelect: "",
      searchUnitOutletVal: ""
    };
  },
  created() {
    this.searchUser();
  },
  methods: {
    enableUser(status, userInfo) {
      userInfo.status = status;
      this.$http
        .post("/api/user/user/enable", userInfo)
        .then(resp => {
          console.log(resp);
          let data = resp.data;
          let code = data.code;
          if (0 == code) {
            this.$message({
              message: resp.message,
              type: "success"
            });
            this.searchUser();
          } else {
            this.$alert(resp.message, "温馨提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(e => {
          this.$alert("请检查网络连接：" + e, "错误提示", {
            confirmButtonText: "确定"
          });
        });
    },
    searchUserCategorySelectChange(val) {
      this.searchUserCategorySelectVal = val;
    },
    searchChannelSelectChange(val) {
      this.searchChannelSelectVal = val;
    },
    searchRegionalSubBranchChange(val) {
      this.searchRegionalSubBranchVal = val;
      this.searchUnitOutletSelect = "";
      this.searchGetUnitOutlet(val);
    },
    searchUnitOutletChange(val) {
      this.searchUnitOutletVal = val;
    },
    searchGetChannel() {
      this.$http
        .post("/api/channel-service/channel/logged/all", {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        })
        .then(resp => {
          let data = resp.data;
          console.log(data);
          if (data.code === "success") {
            this.searchChannels = data.resultList;
          }
        })
        .catch(e => {
          this.$alert("请检查网络" + e, "错误提示", {
            confirmButtonText: "确定"
          });
        });
    },
    searchGetRegionalSubBranch() {
      this.$http
        .get("/api/user-service/dotnode/getSubBranch")
        .then(resp => {
          let data = resp.data;
          console.log(data);
          if (data.code === "0") {
            this.searchRegionalSubBranchs = data.data;
          }
        })
        .catch(e => {
          this.$alert("请检查网络" + e, "错误提示", {
            confirmButtonText: "确定"
          });
        });
    },
    searchGetUnitOutlet(regional) {
      this.$http.get("/api/user-service/dotnode/getUnitOutletAll?regional=" + regional, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data);
        if (data.code === "0") {
          this.searchUnitOutlets = data.data;
        }
      })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },
    exportUser() {
      let reqParam = {
        currentPage: this.currentPage,
        size: this.pageSize,
        key: this.key,
        startRegisterTime: this.registerTime[0],
        endRegisterTime: this.registerTime[1]
      };
      if (
        "" != this.searchUserCategorySelectVal &&
        "-1" != this.searchUserCategorySelectVal
      ) {
        reqParam.userCategory = this.searchUserCategorySelectVal;
      }
      if (
        "" != this.searchRegionalSubBranchVal &&
        "-1" != this.searchRegionalSubBranchVal
      ) {
        reqParam.regionalSubBranch = this.searchRegionalSubBranchVal;
      }
      if (
        "" != this.searchUnitOutletVal &&
        "-1" != this.searchUnitOutletVal
      ) {
        reqParam.companyName = this.searchUnitOutletVal;
      }
      if (
        "" != this.searchChannelSelectVal &&
        "-1" != this.searchChannelSelectVal
      ) {
        reqParam.channelId = this.searchChannelSelectVal;
      }
      if ("" != this.status && "3" != this.status) {
        reqParam.status = this.status;
      }

      this.$http({
        url: '/api/user-service/user/export',
        method: 'post',
        responseType: 'blob',
        data: reqParam,
        timeout: 600000,
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(res => {
        let blob = new Blob([res.data], { type: res.headers['content-type'] });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '用户列表.xlsx'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      })
        .catch(e => { });

      // this.$http.post('/api/user-service/user/export', userIds).then(resp => {
      //     let data = resp.data;
      //     this.channels = data.resultList;
      // }).catch(response => {
      //     this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
      //         confirmButtonText: '确定'
      //     });
      // });
    },
    getChannels(category) {
      this.$http
        .post("/api/channel-service/channel/logged/all?userCategory=" + category, {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        })
        .then(resp => {
          let data = resp.data;
          this.channels = data.resultList;
        })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },
    searchUser() {
      let reqParam = {
        currentPage: this.currentPage,
        size: this.pageSize,
        key: this.key,
        startRegisterTime: this.registerTime[0],
        endRegisterTime: this.registerTime[1]
      };
      if (
        "" != this.searchUserCategorySelectVal &&
        "-1" != this.searchUserCategorySelectVal
      ) {
        reqParam.userCategory = this.searchUserCategorySelectVal;
      }
      if (
        "" != this.searchRegionalSubBranchVal &&
        "-1" != this.searchRegionalSubBranchVal
      ) {
        reqParam.regionalSubBranch = this.searchRegionalSubBranchVal;
      }
      if (
        "" != this.searchUnitOutletVal &&
        "-1" != this.searchUnitOutletVal
      ) {
        reqParam.companyName = this.searchUnitOutletVal;
      }
      if (
        "" != this.searchChannelSelectVal &&
        "-1" != this.searchChannelSelectVal
      ) {
        reqParam.channelId = this.searchChannelSelectVal;
      }
      if ("" != this.status && "3" != this.status) {
        reqParam.status = this.status;
      }
      this.$http.post("/api/user-service/logged/user/search", reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      })
        .then(resp => {
          console.log(resp);
          let pageInfo = resp.data.pageInfo;
          this.tableData = pageInfo.list;
          this.pageSize = pageInfo.pageSize;
          this.total = pageInfo.total;
          this.totalPage = pageInfo.pages;
        })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },
    openUserAddDialog() { },
    addUser(formName, reqParam) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http.post("/api/user-service/user/add", reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          })
            .then(resp => {
              let data = resp.data;
              if (data.code === "success") {
                this.$message({
                  message: "新增会员成功",
                  type: "success"
                });
                this.searchUser();
                this.addUserDialogVisible = false;
                this.resetForm("userForm");
              } else {
                this.$message({
                  showClose: true,
                  message: resp.message,
                  type: "error"
                });
              }
            })
            .catch(e => { });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    updateUser(formName, reqParam) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http.post("/api/user-service/user/update", reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          })
            .then(resp => {
              let data = resp.data;
              if (data.code === "success") {
                this.$message({
                  message: "编辑会员信息成功",
                  type: "success"
                });
                this.addUserDialogVisible = false;
                this.searchUser();
              } else {
                this.$alert("" + data.message, "温馨提示", {
                  confirmButtonText: "确定"
                });
              }
            })
            .catch(e => { });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteUser(userId) {
      this.$confirm("此操作将永久删除该会员, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http.post("/api/user-service/user/delete?userId=" + userId, {}, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          })
            .then(resp => {
              let data = resp.data;
              if (data.code === "success") {
                this.addUserDialogVisible = false;
                this.$message({
                  message: "删除会员成功",
                  type: "success"
                });
                this.searchUser();
              } else {
                this.$alert("" + data.message, "温馨提示", {
                  confirmButtonText: "确定"
                });
              }
            })
            .catch(e => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchUser();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchUser();
    },
    submitUserForm(formName) {
      if (dialogAction.ADD == this.addFlag) {
        let reqParam = {
          userName: this.userForm.userName,
          telephone: this.userForm.telephone,
          channelId: this.userForm.channelId,
          realName: this.userForm.realName,
          userCategory: this.userForm.userCategory
        };
        this.addUser(formName, reqParam);
      } else if (dialogAction.EDIT == this.addFlag) {
        let reqParam = {
          userId: this.userForm.userId,
          userName: this.userForm.userName,
          telephone: this.userForm.telephone,
          channelId: this.userForm.channelId,
          realName: this.userForm.realName,
          integral: this.userForm.integral,
          userCategory: this.userForm.userCategory,
          regionalSubBranch: this.userForm.regionalSubBranch,
          companyName: this.userForm.companyName,
          branchNo: this.userForm.branchNo
        };
        this.updateUser(formName, reqParam);
      } else if (dialogAction.INFO == this.addFlag) {
        this.addUserDialogVisible = false;
      }
    },
    resetForm(formName) {
      this.userCategorySelect = "0";
      this.userChannelSelect = "";
      this.userForm = {};
      this.$refs[formName].resetFields();
    },
    openDialogEvent(addFlag) { },
    channelChangeEvent(val) {
      this.userForm.channelId = val;
    },
    userCategoryChange(val) {
      this.userForm.userCategory = val;
      this.userChannelSelect = "";
      this.getChannels(val);
    },
    openDialog(addFlag, data) {
      if (dialogAction.ADD == addFlag) {
        this.addFlag = dialogAction.ADD;
        this.addUserDialogTitle = "新增";
      } else if (dialogAction.EDIT == addFlag) {
        this.addFlag = dialogAction.EDIT;
        this.addUserDialogTitle = "编辑";
        let tmp = {};
        Object.assign(tmp, data);

        // 绑定渠道
        this.userForm.channelCategory = tmp.channelCategory;
        this.userChannelSelect = tmp.channel.channelName;
        this.userForm = tmp;
        if (tmp.userCategory == 1) {
          this.userCategorySelect = "推手";
        } else {
          this.userCategorySelect = "普通用户";
        }
        this.getChannels(tmp.userCategory);
      } else if (dialogAction.INFO == addFlag) {
        this.addUserDialogTitle = "";
        this.addFlag = dialogAction.INFO;
        let tmp = {};
        Object.assign(tmp, data);
        this.userChannelSelect = tmp.channelId;
        this.userForm = tmp;
        console.log(tmp);
      }
      this.addUserDialogVisible = true;
    },
    updateUserStatus(userId, status) {
      let title = "启用";
      if (status === 0) {
        title = "禁用";
      }
      this.$confirm(
        "此操作会将该会员" + title + ", 是否继续?",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$http.post(
            "/api/user-service/user/updateStatus?userId=" +
            userId +
            "&status=" +
            status, {}, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          })
            .then(resp => {
              let data = resp.data;
              if (data.code === "0" || data.code === 0) {
                this.addUserDialogVisible = false;
                this.$message({
                  message: title + "会员成功",
                  type: "success"
                });
                this.searchUser();
              } else {
                this.$alert("" + data.message, "提示", {
                  confirmButtonText: "确定"
                });
              }
            })
            .catch(e => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消" + title
          });
        });
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/user/userList.vue